"use client";

import { mutate } from "swr";
import { ContestAPI } from "@/restapi/contest";
import { ContestFindRequest } from "./useContestFind";

export const useContestDelete = () => {
  const submitDelete = async (request: ContestFindRequest) => {
    try {
      // APIにPOSTリクエストを送信してデータを取得
      const res = await ContestAPI.delete(request);

      // キャッシュを更新
      mutate(`contest-delete-${JSON.stringify(request)}`, res, false);

      // 一覧系の再検証: useContestSearch が生成する key は "contest-list?{params}&page={page}"
      mutate((key) => typeof key === "string" && key.startsWith("contest-list?"));

      return res;
    } catch (err) {
      console.error("Failed to submit score:", err);
      throw err; // エラー処理
    }
  };

  return {
    submitDelete,
  };
};
